class Colors {

    static bySign(amount: number | string, alpha = 1): string {
        return (Number(amount) < 0) ? this.red(alpha) : this.green(alpha)
    }

    static redOrangeByThreshold(redIfLower: number, orangeIfLower: number, amount: number, alpha = 1): string {
        if (amount > orangeIfLower) return this.green(alpha)
        if (amount < redIfLower) return this.red(alpha)
        return this.orange(alpha)
    }

    static green(alpha = 1): string {
        return `rgba(51, 153, 51, ${alpha})`
    }

    static red(alpha = 1): string {
        return `rgba(231, 37, 37, ${alpha})`
    }

    static orange(alpha = 1): string {
        return `rgba(252, 186, 3, ${alpha})`
    }

    static somberBlue(alpha = 1): string {
        return `rgba(45, 65, 105, ${alpha})`
    }
}

export default Colors
